import React, { useState } from 'react';

import SatSelect from '@components/common/satUI/SatSelect';
import SatInput from '@components/common/satUI/SatInput';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import SatButton from '@components/common/satUI/SatButton';

import {
  PROCESS_TYPE_CODE,
} from '@common/constants';
import { getToday, addDates } from '@common/utils/date';

const AppListHeader = props => {
  const {
    searchParams: { searchStartDate, searchEndDate, searchState, searchName },
    onChangeSearchParams,
    onChangeSearchDate,
    compCd,
    handelSelectCompay,
  } = props;

  const [searchNameInput, setSearchNameInput] = useState(searchName);
  return (
    <div className="tbl-header">
      {/* <!-- 2022.02.15: thx-call-left 추가 --> */}
      <div className="data-group-left">
        <div className="data-area">
          <span className="data-tit">조회기간</span>
          <SatDatePicker
            size={'small'}
            value={searchStartDate}
            disabledDates={[
              addDates(getToday(), 'year', -1, 'yyyyMMdd'),
              searchEndDate,
            ]}
            onChange={value => onChangeSearchParams('searchStartDate', value)}
            noDisableCss={true}
          />
          <span className="tilde">~</span>
          <SatDatePicker
            size={'small'}
            value={searchEndDate}
            disabledDates={
              $utils.isDevLocal ? [] : [searchStartDate, getToday('yyyyMMdd')]
            }
            onChange={value => onChangeSearchParams('searchEndDate', value)}
            noDisableCss={true}
          />
        </div>
      </div>
      <div className="right-area h-40">
        {/* 20230913 회사 선택 삭제 */}
        {/* <SatSelect
          title={'회사선택'}
          value={compCd}
          options={[
            { label: '전체', value: 'ALL' },
            { label: '구.KB', value: PRODUCT_COMP_CD.kb },
            { label: '구.푸르덴셜', value: PRODUCT_COMP_CD.pr },
          ]}
          initOption={{ label: '', value: '', useOption: false }}
          readOnly={false}
          onChange={value => handelSelectCompay(value.value)}
          // validRule={[
          //   {
          //     rule: () => !row.validErrStatus.includes('payinPeriodInfo'),
          //   },
          // ]}
          size="small"
          border={true}
        /> */}

        <SatSelect
          size={'small'}
          border
          // width={'16.2rem'}
          width={'12.2rem'}
          title={'진행상태 선택'}
          value={searchState}
          options={
            /* 20230913 푸르덴셜의 진행 상태로 통일 */
            PROCESS_TYPE_CODE.map(option => {
              return { label: option.label, value: option.value };
            })
            // compCd !== PRODUCT_COMP_CD.kb
            //   ? PROCESS_TYPE_CODE.map(option => {
            //       return { label: option.label, value: option.value };
            //     })
            //   : KB_THANKYOUCALL_STATUS_OPTIONS.map(option => {
            //       return { label: option.label, value: option.value };
            //     })
          }
          initOption={{ useOption: true, label: '전체', value: '' }}
          onChange={option => onChangeSearchParams('searchState', option.value)}
          // disabled={compCd === 'ALL'}
          customStyleClass="mgl-8"
        />
        <div className="sch-box">
          <SatInput
            type={'search'}
            value={searchNameInput}
            placeholder={'이름으로 고객을 검색하세요.'}
            onChange={setSearchNameInput}
            onPressEnter={() =>
              onChangeSearchParams('searchName', searchNameInput)
            }
            onBlur={() => onChangeSearchParams('searchName', searchNameInput)}
          />
        </div>
      </div>
    </div>
  );
};

export default AppListHeader;
